var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.7143,
    height: 33.7143,
    rx: 16.8571,
    fill: "#4880FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3546_20025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6197 11.1886L21.9536 14.5224L13.5147 22.9613L10.1827 19.6275L18.6197 11.1886ZM24.4834 10.3845L22.9966 8.89774C22.422 8.32315 21.489 8.32315 20.9124 8.89774L19.4883 10.3219L22.8221 13.6558L24.4834 11.9946C24.929 11.5489 24.929 10.8302 24.4834 10.3845ZM8.43799 24.3135C8.37732 24.5865 8.62385 24.8312 8.89693 24.7648L12.612 23.8641L9.27999 20.5302L8.43799 24.3135Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3546_20025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.3889,
    height: 16.3889,
    fill: "white",
    transform: "translate(8.42871 8.42773)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.c2a9166af82c2fde0b311f8124c88c24.svg";
export { ForwardRef as ReactComponent };